import React, { useEffect, useState } from "react";
import Loader from "../../SharedLayouts/Loader";
import Dots from "../../Icons/Dots";
import { Box } from "@mui/system";
import GridTable from "../../table/gridTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllWithdrawalReqs } from "../../../store/actions/withdrawal/fetchAllWithdrawalReqs";
import WithdrawalMenu from "../../menus/WithdrawalMenu";
import ApprovewithdrawalModal from "../../modal/ApproveWithdrawalModal";
import useCurrency from "../../../hooks/useCurrency";
import CancelWithdrawal from "../../modal/CancelWithdrawal";
import { getCurrencySymbol } from "../../../Helper/getCurrencySymbol";
import { getDonations } from "../../../store/actions/HWS/getDonations";

function DonationTable() {
  const dispatch = useDispatch();

  const [contextMenu, setContextMenu] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedWithdrawalId, setSelectedWithdrawalId] = useState(null);

  const [_currency, getAmount] = useCurrency();

  const { pending, donations, donationsInfo } = useSelector(
    (state) => state?.transactions
  );

  const user = useSelector((state) => state.onboarding.user);

  useEffect(() => {
    dispatch(getDonations());
  }, [dispatch]);

  const handleContextMenu = (event, params) => {
    event.preventDefault();
    setSelectedRow(params.row);
    setSelectedWithdrawalId(params.row.id);
    if (
      params.row.requestStatus !== "approved" &&
      params.row.requestStatus !== "cancelled"
    ) {
      setContextMenu({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
      });
    } else {
      setContextMenu(null);
    }
  };

  const columns = [
    {
      field: "ID",
      headerName: "ID",
      renderCell: (params) => params.row?.id,
    },
    {
      field: "userId",
      headerName: "User ID",
      renderCell: (params) => params.row?.user?.id,
    },
    {
      field: "Name",
      headerName: "Name",
      width: 150,
      renderCell: (params) => params.row?.user?.name,
    },

    {
      field: "email",
      headerName: "Email",
      width: 300,
      renderCell: (params) => params.row?.user?.email,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 150,
      renderCell: (params) =>
        `${getCurrencySymbol(params.row?.currency)} ${getAmount(
          params.row?.amount
        )}`,
    },

    {
      field: "Date",
      headerName: "Date",
      width: 200,
      renderCell: (params) => new Date(params.row?.created_at)?.toDateString(),
    },
  ];

  return (
    <div className="mt-10 mb-8">
      <div className="bg-white">
        {!pending ? (
          <Box sx={{ overflowX: "auto", width: "100%", cursor: "pointer" }}>
            <GridTable
              // type={"withdrawal requests"}
              rows={donations}
              noReport
              columns={columns}
              pageInfo={donationsInfo}
              getRowId={(row) => row.id}
              // onRowClick={handleRowClick}
            />
          </Box>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}

export default DonationTable;
